<div class="hdis-alert-message" [ngClass]="alertClass">
  <mat-icon class="alert-icon">{{ defaultIcon }}</mat-icon>
  <div class="alert-content">
    <ng-content></ng-content>
  </div>
</div>
